<div class="employee-info-container">
    <div class="employee-header">
        <div class="pb-3">
            <h1
                class="m-0"
                translate="TRAVEL_INFO_FOR_TITLE"
                [translateParams]="{ value: employee.employeeName ? employee.employeeName : '' }"
            ></h1>
            <div class="text-disabled">
                {{ 'TRANSPORT' | translate }}: {{ employee.transport.toUpperCase() | translate }}
            </div>
        </div>
        <app-route-key-numbers class="pb-3" [printView]="true" [keyNumbers]="employee.keyNumbers"></app-route-key-numbers>
    </div>
    <app-route-planning-tasks [pdfView]="true" [visits]="employee.tasks"
                              [routeSolution]="routeSolution"></app-route-planning-tasks>
<!--    <img class="pt-3" [src]="mapImageUrl" *ngIf="includeMap"/>-->
</div>
